import { Component } from '@angular/core';
import { SELLER_SUPPORT_HOME_LINK } from '~shared/constants/links.constants';

@Component({
  selector: 'app-order-return-instructions',
  templateUrl: './order-return-instructions.component.html',
  styleUrls: ['./order-return-instructions.component.scss']
})
export class OrderReturnInstructionsComponent {
  public readonly linkToFAQs = SELLER_SUPPORT_HOME_LINK;
}
